import { render, staticRenderFns } from "./CatalogCloneControl.vue?vue&type=template&id=c4ba055c&"
import script from "./CatalogCloneControl.vue?vue&type=script&lang=js&"
export * from "./CatalogCloneControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports